// extracted by css-extract-rspack-plugin
export default {"mobileGrid":"_713471b9"};